import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { projectPlans, recurringPlans } from "@/lib/commercial-content";
import { trackBudgetRequest } from "@/lib/analytics";

const PlansPage = () => (
  <main id="main-content" className="bg-[#0a0a0a] pt-24">
    <section className="bg-[#ff6b35] noise py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="max-w-5xl">
          <div className="inline-block bg-[#0a0a0a] text-white px-3 py-1 brutal-border font-mono text-xs uppercase tracking-widest mb-5">
            Planos e investimento
          </div>
          <h1 className="font-display text-[#0a0a0a] text-[2.6rem] min-[380px]:text-5xl sm:text-7xl lg:text-8xl uppercase leading-[0.9]">
            Preços claros desde EUR 290 + IVA
          </h1>
          <p className="mt-6 max-w-3xl text-[#0a0a0a]/80 text-lg sm:text-xl leading-snug">
            Os valores abaixo são pontos de partida e acrescem IVA. A proposta final depende do escopo,
            integrações, conteúdo, urgência e complexidade técnica de cada projeto.
          </p>
          <Link
            to="/contacto"
            onClick={() => trackBudgetRequest("plans_hero")}
            className="btn-brutal mt-8 inline-flex"
          >
            <span>Pedir proposta</span>
            <ArrowRight size={18} className="shrink-0" />
          </Link>
        </div>
      </div>
    </section>

    <section className="bg-[#0a0a0a] py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="mb-10">
          <p className="font-mono text-xs uppercase tracking-widest text-[#ff6b35] mb-3">
            Projetos pontuais
          </p>
          <h2 className="font-display text-white text-4xl sm:text-6xl uppercase leading-none">
            Criação e implementação
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {projectPlans.map((plan) => (
            <article key={plan.name} className="brutal-card bg-white p-6 flex min-h-[420px] flex-col">
              <div className="mb-6">
                <p className="font-mono text-xs uppercase tracking-widest text-[#ff6b35] mb-3">
                  {plan.category}
                </p>
                <h3 className="font-display text-[#0a0a0a] text-4xl uppercase leading-none">
                  {plan.name}
                </h3>
                <p className="mt-3 font-mono text-xs uppercase tracking-widest text-[#0a0a0a]">
                  {plan.price}
                </p>
                <p className="mt-5 text-[#0a0a0a]/75 leading-snug">{plan.desc}</p>
              </div>
              <ul className="mt-auto space-y-3">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex gap-3 text-[#0a0a0a]/80 leading-snug">
                    <span className="mt-2 h-2 w-2 bg-[#ff6b35] brutal-border shrink-0" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="bg-white py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div>
            <p className="font-mono text-xs uppercase tracking-widest text-[#ff6b35] mb-3">
              Recorrência
            </p>
            <h2 className="font-display text-[#0a0a0a] text-4xl sm:text-6xl uppercase leading-none">
              Suporte e evolução
            </h2>
          </div>
          <Link
            to="/contacto"
            onClick={() => trackBudgetRequest("plans_recurring")}
            className="inline-flex items-center gap-2 font-mono uppercase text-xs tracking-widest text-[#0a0a0a] hover:text-[#ff6b35] transition-colors"
          >
            <span>Pedir proposta</span>
            <ArrowRight size={16} className="shrink-0" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {recurringPlans.map((plan) => (
            <article key={plan.name} className="brutal-card bg-[#ff6b35] p-6 flex min-h-[340px] flex-col">
              <h3 className="font-display text-[#0a0a0a] text-4xl uppercase leading-none">
                {plan.name}
              </h3>
              <p className="mt-3 font-mono text-xs uppercase tracking-widest text-white">
                {plan.price}
              </p>
              <ul className="mt-7 space-y-3">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex gap-3 text-[#0a0a0a]/80 leading-snug">
                    <span className="mt-2 h-2 w-2 bg-white brutal-border shrink-0" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  </main>
);

export default PlansPage;
